import React, { useEffect, useState } from 'react';
import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Container,
    Form,
    Image,
    Modal,
    Stack,
    Table,
} from 'react-bootstrap';
import NoDraft from '../../Assets/Img/noDrafts.png';
import { useNavigate } from 'react-router';
import LoadingComponent from '../LoadingComponent';
import { useTranslation } from 'react-i18next';
import { frenchFormatDate } from '../../helper';
import { useBackOfficeListMutation } from './backOfficeApi';
import AddBackOffice from './addBackOffice';

const BackOfficeList = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [edit, setEdit] = useState({});
    const config = { email: '', mobile: '' };
    const [backOfficeList] = useBackOfficeListMutation();
    const [backOfficeData, setBackOfficeData] = useState([]);
    const [pageCount, setPageCount] = useState(1);

    useEffect(() => {
        if (loading) {
            (async () => {
                let { data } = await backOfficeList(config);
                console.log(data, 'datadata');
                setBackOfficeData(data);
                setLoading(false);
            })();
        }
    }, [loading]);
const handleFilterChange = async (page) => {
    setPageCount(page);
    setLoading(true);
    let { data } = await backOfficeList({ ...config, page, pageSize: 50 }); // adjust pageSize
    setBackOfficeData(data);
    setLoading(false);
};
    // const handleFilterChange = (count = 1) => {
    //     setLoading(true)
    // }

    // const handleChange = (e) => {
    //     console.log(e.target.value, "e.target.value");

    //     setPatientListConfig((prevValues) => {
    //         return {
    //             ...prevValues,
    //             [e.target.name]: e.target.value

    //         }
    //     });
    // }

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <Container fluid className="list_wrapper">
                <Stack direction="horizontal" gap={3} className="mb-3">
                    <div className="ms-auto">
                        {/* <Button variant='light' onClick={() => { setEditData({}); setShow(true) }}><Plus width={14} height={14} />{t("addPatient")}</Button> */}
                        <AddBackOffice setLoading={setLoading} />
                    </div>
                </Stack>
                <Card>
                    {/* <Card.Header>
                        <Stack direction="horizontal" gap={3} className='listing_filters'>
                            <Stack direction="horizontal" gap={3}>
                                <Form.Control type='text' onChange={handleChange} value={patientListConfig.search} name='search' placeholder={t("search")} />
                                <Form.Control type='date' onChange={handleChange} name='startDate' />
                                <Form.Control type='date' onChange={handleChange} name='endDate' />
                                <Button variant='secondary' onClick={() => handleFilterChange()}>{t("search")}</Button>
                            </Stack>
                            <div className="ms-auto">
                                <Button variant='link' className='' onClick={() => {
                                    setPatientListConfig(config)
                                    setLoading(true)
                                }}>
                                    {t("resetFilters")}
                                </Button>
                            </div>
                        </Stack>
                    </Card.Header> */}
                    <Card.Body className="table_outer">
                        <Table>
                            <thead>
                                <tr>
                                    {/* <th><input type='checkbox' /></th> */}
                                    <th></th>
                                    <th>{t('name')}</th>
                                    <th>{t('email')}</th>
                                    <th>{t('createdOn')}</th>
                                    <th className="text-center">
                                        {t('status')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {backOfficeData.length > 0 ? (
                                    backOfficeData.map((item, index) => (
                                        <tr key={index}>
                                            {/* <td><input type='checkbox' /></td> */}
                                            <td></td>

                                            <td>
                                                {item?.name} {item?.lastName}
                                            </td>
                                            <td>{item.email}</td>
                                            <td>
                                                {frenchFormatDate(
                                                    item.createdDate
                                                )}
                                            </td>
                                            <td>
                                                <Stack
                                                    direction="horizontal"
                                                    gap={1}
                                                >
                                                    <div className="m-auto">
                                                        <Badge className="status_badge">
                                                            Active
                                                        </Badge>
                                                    </div>
                                                </Stack>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6}>
                                            <Stack
                                                gap={2}
                                                className="mt-5 mb-5 mx-auto text-center"
                                            >
                                                <Image
                                                    src={NoDraft}
                                                    width={88}
                                                    className="mx-auto"
                                                />
                                                <h4>{t('noDataAvailable')}</h4>
                                                <p>
                                                    {t("youHaven'tCreatedAny")}
                                                </p>
                                            </Stack>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};

export default BackOfficeList;
